import { create } from 'zustand';

import type { BoardElementId } from './boardSelectionStore';

interface BoardInteractionState {
  draggingIds: BoardElementId[];
  resizingIds: BoardElementId[];
}

interface BoardInteractionActions {
  isInteractingWith: (elementId: BoardElementId) => boolean;
  setDragging: (elementId: BoardElementId, isDragging: boolean) => void;
  setResizing: (elementId: BoardElementId, isResizing: boolean) => void;
  resetBoardInteraction: () => void;
}

export type BoardInteractionStore = BoardInteractionState & BoardInteractionActions;

const initialState: BoardInteractionState = {
  draggingIds: [],
  resizingIds: [],
};

export const useBoardInteractionStore = create<BoardInteractionStore>((set, get) => ({
  ...initialState,

  isInteractingWith: (elementId) => {
    const { draggingIds, resizingIds } = get();
    return draggingIds.includes(elementId) || resizingIds.includes(elementId);
  },

  setDragging: (elementId, isDragging) =>
    set((state) => ({
      draggingIds: updateInteractionIds(state.draggingIds, elementId, isDragging),
    })),

  setResizing: (elementId, isResizing) =>
    set((state) => ({
      resizingIds: updateInteractionIds(state.resizingIds, elementId, isResizing),
    })),

  resetBoardInteraction: () => set(initialState),
}));

function updateInteractionIds(
  elementIds: BoardElementId[],
  elementId: BoardElementId,
  active: boolean
) {
  if (active) {
    return elementIds.includes(elementId) ? elementIds : [...elementIds, elementId];
  }

  return elementIds.filter((currentElementId) => currentElementId !== elementId);
}
